import React, { useState } from "react";
import CoreHttpHandler from "../http/services/CoreHttpHandler";
import {
	ToastAlertSuccess,
	ToastAlertError,
	LoadingButton,
} from "../reauseble";
import { ToastContainer } from "react-toastify";
import loginImg from "../assets/images/register-login.png"
import PageHeader from "../pages/components/PagesHeaderComponent/PageHeader";
import { Input } from "antd";
import { Button } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, LinearProgress } from "@mui/material";
const ResetPassword = () => {

	const navigate = useNavigate();
	const location = useLocation();
	const [loading, setLoading] = useState(false);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirmpassword, setConfirmPassword] = useState("");

	const handleReset = (e) => {
		e.preventDefault();
		if (confirmpassword === password) {

			if (password && email) {
				setLoading(true);
				e.preventDefault();
				CoreHttpHandler.request(
					"forms",
					"reset",
					{
						token: location?.pathname?.split("/reset-password/")[1],
						newPassword: password,
						email: email,
					},
					(response) => {
						setLoading(false);
						setEmail("");
						setPassword("");
						setConfirmPassword("");
						ToastAlertSuccess("Your Password is successfully changed");
						navigate("/");
					},
					(err) => {
						setLoading(false);
						ToastAlertError(
							err?.response?.data?.message
								? err?.response.data.message
								: "something went wrong"
						);
					}
				);
			} else {
				ToastAlertError("Please fill all fields!");
			}
		} else {
			ToastAlertError("Passwords do not match!");
		}

	};
	return (
		<>
			<PageHeader heading={"Reset Password"} />
			<section className='main_form forgot_sec'>
				{/* <canvas></canvas> */}
				<div className='container flex_btw'>
					<div className="login_img">
						<img src={loginImg} />
					</div>

					<div className='inner_sec'>

						<div className="inputs forgotInp">

							<h2>Reset Your Password</h2>

							{loading ?
								<Box sx={{ my: '5rem' }}>
									<LinearProgress color="success" />
								</Box>
								:
								<>
									<Input placeholder="Email" value={email}
										required
										onChange={(e) =>
											setEmail(e.target.value)
										} />
									<Input placeholder="Password*" value={password}
										required
										onChange={(e) =>
											setPassword(e.target.value)
										} />
									<Input placeholder="Confirm Password*" value={confirmpassword}
										required
										onChange={(e) =>
											setConfirmPassword(e.target.value)
										} />
									<Button className="forgot_btn" onClick={handleReset} variant="primary">Reset My Password</Button>
								</>
							}

						</div>

					</div>
				</div>
			</section>
		</>
	);
};

export default ResetPassword;
